<template>
  <div class="setting-box">
    <div class="nextBtnBox">
      <div class="lastBox">
        <div class="lastBtn pointer" @click="backStep">
          {{ "<<" }}
        </div>
      </div>
    </div>
    <!-- 步骤 -->
    <div class="top">
      <div class="topItem m10R activeColor">
        <div class="topItemNumBox m5R activeBg">
          1
        </div>
        <div class="topItemName">填写信息</div>
      </div>
      <div class="topItem greyColor m10R">——</div>
      <div class="topItem activeColor">
        <div class="topItemNumBox m5R activeBg">
          2
        </div>
        <div class="topItemName">设定标签</div>
      </div>
    </div>
    <!-- 标签内容 -->
    <div class="contaner">
      <div class="contanerName">设定标签
        <div class="contanerDesc" style="display: inline-block; margin-left: 27px;">设定标签有利于文章搜索</div>
      </div>
      <div class="tagBox">
        <div class="tagItem" v-for="(item, index) in tagList" :key="index">
          <div class="tagName">
            {{ item.name }}
          </div>
          <div class="tagPunctuation">:</div>
          <div class="tagVal" :class="item.blurStatus ? 'isBlurBox' : ''">
            <span v-if="item.blurStatus">{{ item.value }}</span>
            <input
              type="text"
              class="valueInput"
              v-if="!item.blurStatus"
              placeholder="请输入标签内容"
              v-model="item.value"
              @blur="inputBlur(item)"
            />
          </div>
          <img
            src="@/assets/images/ic_tuichu@3x.png"
            class="closeIcon pointer"
            alt=""
            v-if="item.blurStatus"
            @click="delTag(item)"
          />
        </div>
      </div>
      
      <!-- 可见范围 -->
      <div class="category-box">
        <div class="category-title">可见范围
          <el-radio-group v-model="form.visibleRange" style="margin-left: 27px;">
            <el-radio :label="0">公开</el-radio>
            <el-radio :label="1">私密</el-radio>
          </el-radio-group>
        </div>
      </div>
      
      <!-- 设置价格 -->
      <div class="category-box">
        <div class="category-title">设置价格
          <div class="contanerDesc" style="display: inline-block; margin-left: 27px;">选择付费时，需设置蜘币价格，阅读2分钟后出现付费提示。</div>
        </div>
        <div class="price-radio-box">
          <el-radio-group v-model="form.priceType" size="small">
            <el-radio :label="0" class="price-radio">免费</el-radio>
            <el-radio :label="1" class="price-radio">蜘币</el-radio>
            <div class="price-select-box">
              <el-select v-model="form.price" placeholder="请选择价格" class="price-select" size="small">
                <el-option v-for="option in priceOptions" :key="option" :label="option" :value="option"></el-option>
              </el-select>
              <span class="price-unit">元</span>
            </div>
          </el-radio-group>
        </div>
      </div>
    </div>
    
    <!-- 发布按钮 -->
    <div class="nextBtnBox">
      <div class="lastBox">
        <div class="lastBtn pointer" @click="backStep">
          {{ "<<" }}
        </div>
      </div>
      <div class="btnBox">
        <div class="nextBtn pointer" @click="publish">发布</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";
export default {
  name: "settingDetail",
  props: {
    articleData: {
      type: Object,
      default: {},
    },
    articleId: {
      type: String,
      default: '',
    },
    saveStatus: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        keyWord: "", //关键词
        visibleRange: 0, // 0公开 1付费
        priceType: 0, // 0免费 1蜘币
        price: 2, // 蜘币价格
      },
      tagList: [
        {name: "标签1", value: "", blurStatus: false},
        {name: "标签2", value: "", blurStatus: false},
        {name: "标签3", value: "", blurStatus: false},
        {name: "标签4", value: "", blurStatus: false},
        {name: "标签5", value: "", blurStatus: false},
      ],
      priceOptions: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20], // 蜘币价格选项
    };
  },
  created() {
    console.log('settingDetail created');
    console.log('articleData:', this.articleData);
    console.log('articleId:', this.articleId);
    console.log('saveStatus:', this.saveStatus);
    
    // 从articleData中读取标签信息
    if (this.articleData && this.articleData.keyWord) {
      console.log('读取到已有的标签信息:', this.articleData.keyWord);
      const tags = this.articleData.keyWord.split(',');
      tags.forEach((tag, index) => {
        if (index < this.tagList.length && tag.trim()) {
          this.tagList[index].value = tag.trim();
          this.tagList[index].blurStatus = true;
        }
      });
      // 重新计算关键字
      this.computedKeyWord();
    }
    
    // 从articleData中读取其他设置
    if (this.articleData) {
      if (this.articleData.visibleRange !== undefined) {
        this.form.visibleRange = this.articleData.visibleRange;
      }
      // 根据price判断收费/免费：有价格则为蜘币付费，无价格则为免费
      const priceVal = this.articleData.price;
      if (priceVal !== undefined && priceVal !== null && Number(priceVal) > 0) {
        this.form.priceType = 1; // 付费
        this.form.price = Number(priceVal);
      } else {
        this.form.priceType = 0; // 免费
      }
    }
  },
  mounted() {
    console.log('settingDetail mounted');
    console.log('articleId:', this.articleId);
    console.log('saveStatus:', this.saveStatus);
  },
  methods: {
    // 返回上一步
    backStep() {
      // 将设置页的表单数据传回，避免返回后丢失价格、可见范围等设置
      this.$emit('backStep', {
        keyWord: this.form.keyWord,
        visibleRange: this.form.visibleRange,
        priceType: this.form.priceType,
        price: this.form.price,
      });
    },
    // 发布文章
    publish() {
      // 验证价格
      if (this.form.visibleRange == 1 && this.form.priceType == 1 && !this.form.price) {
        this.$message({
          message: "请选择蜘币价格",
          type: "warning",
        });
        return;
      }
      
      // 合并文章数据和标签数据
      let publishData = Object.assign({}, this.articleData, {
        keyWord: this.form.keyWord,
        visibleRange: this.form.visibleRange,
        priceType: this.form.priceType,
        price: this.form.priceType== 1? this.form.price: 0, 
      });
      
      // 根据saveStatus决定调用哪个API方法
      if (this.saveStatus === 1 && this.articleId) {
        // 编辑模式
        console.log('编辑模式，调用editArticle API');
        api.article.editArticle(this.articleId, publishData).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "发布成功",
              type: "success",
            });
            this.$emit('publishSuccess', this.form.visibleRange);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message({
            message: "发布失败",
            type: "error",
          });
        });
      } else {
        // 新增模式
        console.log('新增模式，调用release API');
        api.article.release(publishData).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "发布成功",
              type: "success",
            });
            this.$emit('publishSuccess', this.form.visibleRange);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message({
            message: "发布失败",
            type: "error",
          });
        });
      }
    },
    // 删除tag标签
    delTag(val) {
      val.value = "";
      val.blurStatus = false;
      this.computedKeyWord();
    },
    // 计算关键字
    computedKeyWord() {
      let arr = [];
      this.tagList.forEach((item) => {
        if (item.blurStatus) {
          arr.push(item.value);
        }
      });
      this.form.keyWord = arr.join(",");
    },
    // 输入框失去焦点
    inputBlur(val) {
      if (val.value == "") {
        val.blurStatus = false;
        this.$set(val, 'blurStatus', false);
      } else {
        val.blurStatus = true;
        this.$set(val, 'blurStatus', true);
      }
      // 计算关键字
      this.computedKeyWord();
    },
  },
};
</script>

<style scoped>
.setting-box {
  min-width: 506px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-left: 1px solid #dcdfe6;
  position: relative;
  min-height: 0;
}

.top {
  display: flex;
  align-items: center;
  padding: 10px;
  padding-top: 20px;
  margin-bottom: 20px;
}

.topItem {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #abaeb3;
}

.topItemNumBox {
  width: 18px;
  height: 18px;
  background: #c4c7cc;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m10R {
  margin-right: 10px;
}

.m5R {
  margin-right: 5px;
}

.activeColor {
  color: #4db4d4;
}

.activeBg {
  background: #4db4d4;
}

.greyColor {
  color: #dcdfe6;
}

.contanerName {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #313233;
  padding-left: 10px;
}

.contanerDesc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #abaeb3;
  padding-left: 10px;
  color: #abaeb3;
  margin-top: 10px;
  margin-bottom: 20px;
}

.tagBox {
  padding: 0 10px;
}

.tagItem {
  display: flex;
  align-items: center;
  padding-left: 10px;
  margin-bottom: 16px;
}

.tagPunctuation {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #313233;
  margin-right: 8px;
  margin-left: 4px;
}

.tagName {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #313233;
}

.valueInput {
  width: 85px;
  height: 20px;
  border: none;
  outline: none;
  font-size: 14px;
}

.valueInput:focus {
  border: none;
}

.tagVal {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  border: 1px solid #abadb3;
}

.isBlurBox {
  color: #4db4d4;
  border: 1px solid #4db4d4;
}

.closeIcon {
  width: 16px;
  height: 16px;
  margin-left: 10px;
  cursor: pointer;
}

.contaner {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.category-box {
  margin-left: 10px;
  margin-top: 40px;
}

.price-box {
  margin-left: 10px;
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.price-label {
  font-size: 14px;
  color: #313233;
  margin-right: 10px;
}

.price-select {
  width: 100px;
}

.price-radio-box {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.price-radio {
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
}

.price-select-box {
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  vertical-align: middle;
}

.price-unit {
  margin-left: 5px;
  font-size: 14px;
  color: #313233;
  line-height: 28px;
}

.nextBtnBox {
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  border-top: 1px solid #dcdfe6;
  background: #fff;
}

.nextBtnBox:first-child {
  border-top: none;
  border-bottom: 1px solid #dcdfe6;
}

.nextBtn {
  width: 70px;
  height: 28px;
  background: #4db4d4;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.activeBlueBg {
  background: #4db4d4;
}

.pointer {
  cursor: pointer;
}

.btnBox {
  padding-left: 10px;
}

.lastBox {
  padding-left: 10px;
}

.lastBtn {
  width: 48px;
  height: 28px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #dcdfe6;
  color: #313233;
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #4db4d4;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #4db4d4;
  background: #4db4d4;
}
</style>